<div class="inbuilt-visual-wrapper-v2">
  @if (heading || (isJSONeditorEnabled && elementData?.type !== 'header')) {
  <div class="card-header">
    <div class="header-content">
      @if (heading) {
      <h4 class="card-title">{{ heading }}</h4>
      } @if (hasNavigationLink) {
      <a
        class="more-details-link"
        [matTooltip]="navigationTooltip"
        matTooltipPosition="above"
        (click)="handleNavigationClick()"
      >
        <mat-icon class="info-icon">info</mat-icon>
        More Info
      </a>
      } @if (isJSONeditorEnabled && elementData?.type !== 'header') {
      <span class="json-editor-icon">
        <mat-icon title="Edit Element JSON" (click)="openJSONeditor()">create</mat-icon>
        <mat-icon class="ms-1" title="Delete Report" (click)="deleteReport()">delete</mat-icon>
      </span>
      }
    </div>
  </div>
  }

  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalEditJSON
  class="modal-demo edit-json-popup"
  (closeModal)="hidepopup('edit')"
>
  <ng-container class="app-modal-header">Visual Editor</ng-container>
  <ng-container class="app-modal-body">
    @if (isJSONeditorPopupOpen) {
    <app-inbuilt-editor
      [initialJson]="elementData?.element_json || {}"
      [queryCode]="elementData?.Constructed_Query || ''"
      (jsonTextChange)="onJsonEditorTextChange($event)"
    ></app-inbuilt-editor>
    }
  </ng-container>
</app-modal>
